import type { PageCard } from '@/play/pageTypes'
import { GrooveLettersCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'groove-letters',
  number: 21,
  title: 'Groove letters',
  question: 'Does watching a letter carved stroke by stroke, then filling the groove with goo, feel like play?',
  status: 'open',
  accent: '#ecdcc8',
  CardArt: GrooveLettersCardArt,
}
